<template>
  <div class="buyer-rfp-table-list padding-t-20 k-page">
    <Table border :columns="tblColumns" :data="tblData" class="invoice-list-table k-table" :loading="isLoading"></Table>
    <div style="margin: 10px;overflow: hidden" v-if="totalData > 20">
      <div style="float: right;">
        <Page :total="totalData" :current="curPage" @on-change="handleChangePage" :page-size="20"></Page>
      </div>
    </div>
    <RfpSummaryModal ref="RfpSummaryModal"/>
  </div>
</template>

<script>
import moment from 'moment'
import RfpSummaryModal from '@/components/rfp-list/SummaryModal'
import { fetchRfps } from '@/services/rfps'

export default {
  components: {
    RfpSummaryModal
  },

  props: {
    searchText: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      curPage: 1,
      isLoading: false,
      tblColumns: [
        {
          title: 'Date',
          key: 'date',
          render: (h, params) => {
            return h('span', moment(params.row.created_at).format('MM/DD/YYYY'))
          }
        },
        {
          title: 'Deadline',
          key: 'deadline',
          className: 'rfp-deadline',
          render: (h, params) => {
            return h('span', moment(params.row.deadline).format('MM/DD/YYYY'))
          }
        },
        {
          title: 'RFP Number',
          key: 'rfp_number',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'text'
                },
                style: {
                  marginRight: '5px',
                  color: '#2d8cf0'
                },
                on: {
                  click: () => {
                    this.$refs.RfpSummaryModal.openModal(params.row.id)
                  }
                }
              }, params.row.rfp_number)
            ])
          }
        },
        {
          title: 'Sent to',
          key: 'sent_to',
          render: (h, params) => {
            const items = params.row.tech_company_value.map(item => h('div', [
              h('Button', {
                props: {
                  type: 'text'
                },
                style: {
                  color: '#2d8cf0'
                },
                on: {
                  click: () => {
                    const routeData = this.$router.resolve({
                      name: 'company',
                      params: {
                        slug: item.split(/,(.+)/)[1].trimStart()
                      },
                      query: {}
                    })
                    window.open(routeData.href, '_blank')
                  }
                }
              }, item.split(/,(.+)/)[0])
            ]))
            return h('div', items)
          }
        },
        {
          title: 'Replies from Tech Providers',
          key: 'reply_count',
          align: 'center'
        },
        {
          title: 'Status',
          key: 'status',
          render: (h, params) => {
            if (params.row.status === 'pending') {
              return h('span', 'Waiting for approval from Kromnix.')
            }
            if (params.row.status === 'approved') {
              return h('span', `Approved by Kromnix. Your RFP has been sent to ${params.row.tech_company_value.length} Tech Providers.`)
            }
            if (params.row.status === 'closed') {
              return h('span', 'Closed')
            }
          }
        }
      ],
      tblData: [],
      totalData: null
    }
  },

  watch: {
    searchText (val) {
      this.curPage = 1
      this.getRfpsList()
    }
  },

  mounted () {
    this.getRfpsList()
  },

  methods: {
    getRfpsList () {
      this.isLoading = true
      let query = `?page=${this.curPage}`
      if (this.searchText) query = query + `&keyword_search=${this.searchText}`
      fetchRfps(query).then(res => {
        this.tblData = res.data.results
        this.totalData = res.data.count
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to fetch rfp list: ', err)
        this.isLoading = false
      })
    },

    handleChangePage (pageNum) {
      this.curPage = pageNum
      this.getRfpsList()
    }
  }
}
</script>
